import { Tenant } from '@app/infrastructure/tenant/model/Tenant';

const TENANT_LOCALE_MAP: Record<Tenant, string> = {
    [Tenant.LT]: 'lt-LT',
    [Tenant.EE]: 'et-EE',
    [Tenant.LV]: 'lv-LV',
};

export const formatEuroValue = (value: number, tenant: Tenant, noDecimals = false): string => {
    const fractionDigits = noDecimals ? 0 : 2;

    return value.toLocaleString(TENANT_LOCALE_MAP[tenant], {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
};
